import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export interface PnlReportColumnConfigItem {
  key: string;
  label: string;
  order: number;
}

export interface PnlReportTableConfig {
  id: number;
  name: string;
  fieldConfigJson: any;
  isDefault: boolean;
  createdById?: number;
  createdAt?: string;
  updatedById?: number;
  updatedAt?: string;
  deletedById?: number;
  deletedAt?: string;
  status?: number;
}

const API_PREFIX = '/contract-management/pnl-report-table-config';

export const pnlReportTableConfigApi = createApi({
  reducerPath: 'pnlReportTableConfigApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PnlReportTableConfig'],
  endpoints: builder => ({
    getPnlReportTableConfigList: builder.query({
      query: () => `${API_PREFIX}/list`,
      providesTags: ['PnlReportTableConfig'],
    }),

    getCurrentPnlReportTableConfig: builder.query({
      query: ({ page }) => `${API_PREFIX}/current-config-page?page=${page}`,
      providesTags: ['PnlReportTableConfig'],
    }),

    getPnlReportTableConfigById: builder.query({
      query: (id: number) => `${API_PREFIX}/${id}`,
      providesTags: (result, error, id) => [{ type: 'PnlReportTableConfig', id }],
    }),

    createPnlReportTableConfig: builder.mutation({
      query: data => ({
        url: `${API_PREFIX}/create-config`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PnlReportTableConfig'],
    }),

    updatePnlReportTableConfig: builder.mutation({
      query: ({ configId, ...data }) => ({
        url: `${API_PREFIX}/${configId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { configId }) => [
        'PnlReportTableConfig',
        { type: 'PnlReportTableConfig', id: configId },
      ],
    }),

    deletePnlReportTableConfig: builder.mutation({
      query: (configId: number) => ({
        url: `${API_PREFIX}/${configId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PnlReportTableConfig'],
    }),

    applyPnlReportTableConfig: builder.mutation({
      query: data => ({
        url: `${API_PREFIX}/apply-config`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['PnlReportTableConfig'],
    }),
  }),
});

export const {
  useGetPnlReportTableConfigListQuery,
  useGetCurrentPnlReportTableConfigQuery,
  useGetPnlReportTableConfigByIdQuery,
  useCreatePnlReportTableConfigMutation,
  useUpdatePnlReportTableConfigMutation,
  useDeletePnlReportTableConfigMutation,
  useApplyPnlReportTableConfigMutation,
} = pnlReportTableConfigApi;

export default pnlReportTableConfigApi;
